export const normalizeLoanProductRecord = (record) => {
    const product = record?.lp || record?.loanproducts || {};
    const category = record?.lc || {};

    return {
        ...record,
        lp: product,
        lc: {
            ...category,
            category_name: category.category_name ?? product.category_name ?? ""
        }
    };
};
